import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { logar, resetReducers } from '../../../actions/Login.action'
import { Form, Input, Button } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import style from './style.module.css'
import { Link } from 'react-router-dom'

class Login extends Component {

  onFinish = values => {
    this.props.logar(values.username, values.password)
  };

  onFinishFailed = errorInfo => {
    // console.log('Failed:', errorInfo)
  };

  render() {
    const { isAuthenticate, loadLogin, isFailure } = this.props.login

    if (isAuthenticate) {
      return false
    }

    if (isFailure) {
      //this.formRef.current.resetFields();
      setTimeout(() => {
        this.props.resetReducers()
      }, 2000)
    }

    return(
      <Form
        name="basic"
        ref={this.formRef}
        initialValues={{ remember: true }}
        onFinish={this.onFinish}
        onFinishFailed={this.onFinishFailed}
      >
        <Form.Item name="username" rules={[{ required: true, message: 'Informe o e-mail ou usuário!' }]}>
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="E-mail ou usuário" />
        </Form.Item>

        <Form.Item name="password" rules={[{ required: true, message: 'Informe a senha!' }]}>
          <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} placeholder="Senha" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" className={style.btnSubmit} disabled={loadLogin}>
            Entrar
          </Button>
        </Form.Item>

        {
          isFailure ? (
            <div>
              <p className={style.loginFailure}>Login ou senha inválido(s)</p>
            </div>
          ) : (
              []
          )
        }

        {/*<Form.Item name="remember" valuePropName="checked" style={{marginBottom: 0}}>
          <Checkbox>Lembre-me</Checkbox>
          </Form.Item>*/}

        <div style={{textAlign: 'center'}}><Link to={`/recuperar`}>Esqueci minha senha</Link></div>
      </Form>
    )
  }
}

const mapStateToProps = state =>
  ({
    login: state.login
  })

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logar, resetReducers }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Login)